var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApprovalWorkflow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 28.443 31.955",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8476",
    "data-name": "Group 8476",
    transform: "translate(-230.456 -7.18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_25122",
    "data-name": "Path 25122",
    d: "M244.5,7.528h-8.78a5.267,5.267,0,0,0-5.268,5.268V33.867a5.267,5.267,0,0,0,5.268,5.268h17.559a5.27,5.27,0,0,0,5.268-5.268v-15.8a1.756,1.756,0,0,0-3.512,0v15.8a1.756,1.756,0,0,1-1.756,1.756H235.724a1.757,1.757,0,0,1-1.756-1.756V12.8a1.757,1.757,0,0,1,1.756-1.756h8.78a1.756,1.756,0,0,0,0-3.512Zm0,11.565-4.026-4.026a1.756,1.756,0,0,0-2.483,2.483l4.026,4.026a3.511,3.511,0,0,0,4.966,0l11.4-11.4A1.757,1.757,0,1,0,255.9,7.693Z",
    transform: "translate(0 0)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprovalWorkflow);
export default __webpack_public_path__ + "static/media/ApprovalWorkflow.fefada7776df3755563317a64ce2413d.svg";
export { ForwardRef as ReactComponent };